<template>
  <form class="md-layout">
    <md-card class="md-layout-item md-size-100">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <md-field :class="getValidationClass('name')">
              <label for="section-name">Section Name</label>
              <md-input name="section-name" id="section-name" v-model="section.name"/>
                <span class="md-error" v-if="!$v.section.name.required">The name is required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="section-description">Description</label>
              <md-input name="section-description" id="section-description" v-model="section.description"/>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="section-icon">Icon</label>
              <md-select name="section-icon" id="section-icon" v-model="section.icon">
                <md-option value="alarm"><md-icon>alarm</md-icon></md-option>
                <md-option value="accessible_forward"><md-icon>accessibility</md-icon></md-option>
                <md-option value="account_box"><md-icon>account_box</md-icon></md-option>
                <md-option value="assessment"><md-icon>assessment</md-icon></md-option>
                <md-option value="book"><md-icon>book</md-icon></md-option>
                <md-option value="business"><md-icon>business</md-icon></md-option>
                <md-option value="email"><md-icon>email</md-icon></md-option>
                <md-option value="event"><md-icon>event</md-icon></md-option>
                <md-option value="check_circle"><md-icon>check_circle</md-icon></md-option>
                <md-option value="help"><md-icon>help</md-icon></md-option>
                <md-option value="laptop"><md-icon>laptop</md-icon></md-option>
                <md-option value="phone_iphone"><md-icon>phone</md-icon></md-option>
                <md-option value="watch"><md-icon>watch</md-icon></md-option>
                <md-option value="eco"><md-icon>eco</md-icon></md-option>
                <md-option value="flag"><md-icon>flag</md-icon></md-option>
                <md-option value="wc"><md-icon>wc</md-icon></md-option>
                <md-option value="flight_takeoff"><md-icon>flight_takeoff</md-icon></md-option> 
                <md-option value="motorcycle"><md-icon>motorcycle</md-icon></md-option>
                <md-option value="pan_tool"><md-icon>pan_tool</md-icon></md-option>
                <md-option value="pets"><md-icon>pets</md-icon></md-option>
                <md-option value="star"><md-icon>star</md-icon></md-option>
                <md-option value="print"><md-icon>print</md-icon></md-option>
                <md-option value="reciept"><md-icon>receipt</md-icon></md-option>
                <md-option value="schedule"><md-icon>schedule</md-icon></md-option>
                <md-option value="wifi"><md-icon>wifi</md-icon></md-option>
                <md-option value="stars"><md-icon>stars</md-icon></md-option>
                <md-option value="store"><md-icon>store</md-icon></md-option>
                <md-option value="tram"><md-icon>tram</md-icon></md-option>
                <md-option value="wb_cloudy"><md-icon>cloud</md-icon></md-option>
                <md-option value="supervisor_account"><md-icon>supervisor_account</md-icon></md-option>
                <md-option value="thumb_up"><md-icon>thumb_up</md-icon></md-option>
                <md-option value="work"><md-icon>work</md-icon></md-option>
                <md-option value="vpn_key"><md-icon>vpn_key</md-icon></md-option>
                <md-option value="drive_eta"><md-icon>drive_eta</md-icon></md-option>
                <md-option value="beach_access"><md-icon>beach_access</md-icon></md-option>
                <md-option value="sports_volleyball"><md-icon>sports_volleyball</md-icon></md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="section-image">Image</label>
              <md-file name="section-image" id="section-image"  accept="image/*" @md-change="handleUploadEvent($event)"/>
            </md-field>
          </div>
        </div>
        <div class="md-layout-item md-size-100">
          <md-field>
            <label for="section-image-placement">Image Placement</label>
            <md-select name="section-image-placement" id="section-image-placement" v-model="section.placement">
              <md-option value="background">Background</md-option>
              <md-option value="left">Left</md-option>
              <md-option value="right">Right</md-option>
              <md-option value="centered">Centered</md-option>
              <md-option value="top">Top</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <label for="section-bg-color">Background Color</label>
            <md-input type="color" name="section-bg-color" id="section-bg-color" v-model="section.bg_color_hex" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <label for="section-font-color">Font Color</label>
            <md-input type="color" name="section-font-color" id="section-font-color" v-model="section.font_color_hex" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-100">
          <md-field>
            <label for="section-font">Font</label>
            <md-select name="section-font" id="section-font" class="font-input"  v-model="section.font">
              <md-option value="Alfa Slab One" class="font-alfa-slab-one">Alpha Slab One</md-option>
              <md-option value="Roboto Slab" class="font-roboto-slab">Roboto Slab</md-option>
              <md-option value="Caveat" class="font-caveat">Caveat</md-option>
              <md-option value="Dancing Script" class="font-dancing-script">Dancing Script</md-option>
              <md-option value="Erica One" class="font-erica-one">Erica One</md-option>
              <md-option value="Lato" class="font-lato">Lato</md-option>
              <md-option value="Monospace" class="font-monospace">Monospace</md-option>
              <md-option value="Notable" class="font-notable">Notable</md-option>
              <md-option value="Nunito" class="font-nunito">Nunito</md-option>
              <md-option value="Open Sans" class="font-open-sans">Open Sans</md-option>
              <md-option value="Open Sans Condensed" class="font-open-sans-condensed">Open Sans Condensed</md-option>
              <md-option value="Pinyon Script" class="font-pinyon-script">Pinyon Script</md-option>
              <md-option value="Raleway" class="font-raleway">Raleway</md-option>
              <md-option value="Sans Serif" class="font-sans-serif">Sans Serif</md-option>
              <md-option value="Serif" class="font-serif">Serif</md-option>
              <md-option value="Shadows Into Light" class="font-shadows-into-light">Shadows Into Light</md-option>
              <md-option value="Tangerine" class="font-tangerine">Tangerine</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100">
          <quill-editor ref="myTextEditor"
                        v-model="section.body"
                        :options="editorOption">
          </quill-editor>
          <md-file ref="quillImage" style="display: none"  name="quill-image" id="quill-image"  accept="image/*" @md-change="handleQuillImageEvent($event)"/>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button class="md-primary" v-on:click="save()">Save</md-button>
        <md-button class="md-accent" v-on:click="cancel()">Cancel</md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'

import Quill from 'quill'

var FontAttributor = Quill.import('attributors/class/font');
FontAttributor.whitelist = [
  'lato', 'roboto-slab'
];
Quill.register(FontAttributor, true);

var Size = Quill.import('attributors/style/size');
Size.whitelist = ['14px', '16px', '18px', '24px', '36px', '48px'];
Quill.register(Size, true);

export default {
  name: "SectionEdit",
  mixins: [validationMixin],
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  validations: {
    section: {
      name: {
        required
      }
    }
  },
  data (){
    return {
      editorOption: {
        modules: {
          toolbar: {
            container:[
              [{ 'size': ['14px', '16px', '18px', '24px', '36px', '48px'] }],
              [{ 'font': ['', 'lato', 'roboto-slab']}],
              ['bold', 'italic', 'underline'],
              [{ 'align': [] }],
              [{ 'color': ["#ff4440","#C5DBC9","#0A3F3F","#DBD221"] }, { 'background': ["#ff4440", "#C5DBC9","#0A3F3F","#DBD221"] }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              ['link', 'image', 'video']
            ],
            handlers:{
              'image': () => {
                this.quillImageInput.click()
              }
            }}
        }
      }
    }
  },
  computed:{
    editor() {
      return this.$refs.myTextEditor.quill
    },
    quillImageInput() {
      return this.$refs.quillImage.$refs.inputFile
    }
  },
  methods:{
    async handleUploadEvent ( event){
      let response = await this.$store.dispatch('uploadQuillImage', event[0])
      this.section.image = response.image_url
    },
    async handleQuillImageEvent(event) {
      let response = await this.$store.dispatch('uploadQuillImage', event[0])
      const range = this.editor.getSelection();
      this.editor.insertEmbed(range.index, 'image', response.image_url);
    },
    save() {
      this.section.delta = this.editor.getContents()
      this.section.plain_text = this.editor.getText()
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$emit('save')
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    getValidationClass (fieldName) {
      const field = this.$v.section[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
  }
}
</script>
<style>
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='']::before
{
  content: 'Default';
}
.font-arial span.md-list-item-text{
  font-family: Arial;
}
.font-sans-serif span.md-list-item-text{
  font-family: "Sans Serif";
}
.font-serif span.md-list-item-text{
  font-family: "Serif";
}
.font-monospace span.md-list-item-text{
  font-family: "Monospace";
}
.font-shadows-into-light span.md-list-item-text{
  font-family: "Shadows Into Light";
}
.font-caveat span.md-list-item-text{
  font-family: "Caveat";
}
.font-dancing-script span.md-list-item-text{
  font-family: "Dancing Script";
}
.font-pinyon-script span.md-list-item-text{
  font-family: "Pinyon Script";
}
.font-tangerine span.md-list-item-text{ 
  font-family: "Tangerine";
}
.font-notable span.md-list-item-text{
  font-family: "Notable";
}
.font-alfa-slab-one span.md-list-item-text{
  font-family: "Alfa Slab One";
}
.font-roboto-slab span.md-list-item-text{
  font-family: "Roboto Slab";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='roboto-slab']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='roboto-slab']::before
{
  content: 'Roboto Slab';
  font-family: 'Roboto Slab';
}
.ql-font-roboto-slab {
  font-family: "Roboto Slab";
}
.font-erica-one span.md-list-item-text{
  font-family: "Erica One";
}
.font-lato span.md-list-item-text{
  font-family: "Lato";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='lato']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='lato']::before
{
  content: 'Lato';
  font-family: 'Lato';
}
.ql-font-lato {
   font-family: "Lato";
}
.font-raleway span.md-list-item-text{
  font-family: "Raleway";
}
.font-nunito span.md-list-item-text{
  font-family: "Nunito";
}
.font-open-sans span.md-list-item-text{
  font-family: "Open Sans";
}
.font-open-sans-condensed span.md-list-item-text{
  font-family: "Open Sans Condensed";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
    content: '14px';
    font-size: 14px !important;
    line-height: 150% !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
    content: '16px';
    font-size: 16px !important;
    line-height: 150% !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
    content: '18px';
    font-size: 18px !important;
    line-height: 150% !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
    content: '24px';
    font-size: 24px !important;
    line-height: 150% !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36px"]::before {
    content: '36px';
    font-size: 36px !important;
    line-height: 150% !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="48px"]::before {
    content: '48px';
    font-size: 48px !important;
    line-height: 150% !important;
}
</style>
